import { useRef, useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import styles from "./AwardsRow.module.css";

// Renders a string with **bold** markers as <strong> segments.
const renderBoldText = (text) => {
  if (!text) return null;
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
};

const Card = ({ children, className }) => (
  <div className={`${styles.card} ${className}`}>{children}</div>
);

// Shared accolades/awards card row. Data-driven from the Firestore
// `accolades` collection; used by both the Newsroom and Home pages.
const AwardsRow = ({ items }) => {
  const scrollRef = useRef(null);
  const [showLeftFade, setShowLeftFade] = useState(false);
  const [showRightFade, setShowRightFade] = useState(true);

  const handleScroll = useCallback(() => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftFade(scrollLeft > 0);
      setShowRightFade(scrollLeft < scrollWidth - clientWidth - 1);
    }
  }, []);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  return (
    <div className={styles.mediaRowContainer}>
      {showLeftFade && <div className={styles.gradientLeft}></div>}
      {showRightFade && <div className={styles.gradientRight}></div>}
      <div className={styles.mediaRow} ref={scrollRef}>
        {items.map((item, index) => (
          <motion.div
            key={index}
            className={styles.mediaCard}
            whileHover={{ scale: 1.05 }}
          >
            <Card className={styles.awardCard}>
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className={styles.mediaImage}
                />
                <div className={styles.mediaContent}>
                  <h3 className={styles.mediaTitle}>{item.title}</h3>
                  <div className="mediaTextAcc">
                    <p>{renderBoldText(item.description)}</p>
                  </div>
                </div>
              </a>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AwardsRow;
